// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {color, xScreen} from "@bg/XDL/Utilities";
import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { css } from "styled-components";

customerSelectorToolbarStyles.wrapper = {
    css: css`
        display: grid;
        grid-auto-flow: column;
        grid-template-columns: 1fr;
        grid-auto-columns: auto;
        gap: 8px;
        align-items: flex-end;

        border-bottom: 1px solid ${color("common.border")};
        padding-bottom: 10px;

        ${xScreen("lte", "xs")} {
            grid-template-columns: 1fr auto;
            grid-auto-flow: row;
        }
    `,
};

customerSelectorToolbarStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            & input:not(.react-datetime-picker__inputGroup__input) {
                padding-right: 32px;
            }
        `,
    },
};

customerSelectorToolbarStyles.searchButton = {
    variant: "primary",
    css: css`
        ${xScreen("lte", "xs")} {
            order: 3;
            width: 100%;
            grid-column: 1 / 3;
        }
    `,
};

customerSelectorToolbarStyles.wideCreateNewAddressButton = {
    variant: "secondary",
    css: css`
        padding: 0 22px;
        margin-left: 0;
    `,
};

customerSelectorToolbarStyles.narrowHidden = {
    above: "sm",
    css: css`
        ${xScreen("lte", "xs")} {
            order: 2;
        }
    `,
};

customerSelectorToolbarStyles.overflowMenu = {
    buttonProps: {
        css: css`
            height: 100%;
        `,
    },
    cssOverrides: {
        wrapper: css`
            margin-left: 0;
            height: 100%;
        `,
    },
};
